import { render, staticRenderFns } from "./ModalDesc.vue?vue&type=template&id=0c83ca7b&scoped=true&"
import script from "./ModalDesc.vue?vue&type=script&lang=js&"
export * from "./ModalDesc.vue?vue&type=script&lang=js&"
import style0 from "./ModalDesc.vue?vue&type=style&index=0&id=0c83ca7b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c83ca7b",
  null
  
)

export default component.exports